import { types } from "../types/types";

const initialState = {
    allUserSubscriptions: [],
    pagination: {},
};

const userSubscriptionReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.USER_SUBSCRIPTIONS:
            return {
                ...state,
                allUserSubscriptions: action.payload.data || [],
                pagination: action.payload.pagination || {},
            };
        default:
            return state;
    }
};

export default userSubscriptionReducer;
